export function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 prose prose-invert prose-zinc">
      <h1>Privacy Policy</h1>
      <p>Last updated: 2026-05-07</p>

      <h2>What we collect</h2>
      <ul>
        <li>
          <strong>Email and Google profile</strong> — provided via Google Sign-In.
          Used solely to identify your account.
        </li>
        <li>
          <strong>Session tokens</strong> — stored hashed on our server; raw
          token only stored in your browser to keep you signed in.
        </li>
        <li>
          <strong>Subscription status</strong> — stored on our server.
        </li>
      </ul>

      <h2>What we do NOT collect</h2>
      <ul>
        <li>Your X (Twitter) credentials. The OnlyBans extension reuses your
          existing X session in your browser; we never see your password.</li>
        <li>The list of accounts you block. Block actions happen entirely in
          your browser.</li>
        <li>Browsing history.</li>
      </ul>

      <h2>Third parties</h2>
      <ul>
        <li><strong>Google</strong> — for OAuth sign-in.</li>
        <li><strong>Cloudflare</strong> — hosts our API and database.</li>
      </ul>

      <h2>Data deletion</h2>
      <p>
        Email <span className="font-mono">privacy@onlybans.work</span> from your
        registered address to delete your account.
      </p>
    </div>
  )
}
